/**
 * @generated SignedSource<<0790c12fca335eeceaa948cfa9d78178>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AppraisalMutationsListRemoveMutation$variables = {
  id: string;
};
export type AppraisalMutationsListRemoveMutation$data = {
  readonly deleteAppraisal: {
    readonly id: string;
  };
};
export type AppraisalMutationsListRemoveMutation = {
  response: AppraisalMutationsListRemoveMutation$data;
  variables: AppraisalMutationsListRemoveMutation$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'id',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'id',
            variableName: 'id',
          },
        ],
        concreteType: 'Appraisal',
        kind: 'LinkedField',
        name: 'deleteAppraisal',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'id',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'AppraisalMutationsListRemoveMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'AppraisalMutationsListRemoveMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '2fdbb5dec17bcfc61173fb1720523789',
      id: null,
      metadata: {},
      name: 'AppraisalMutationsListRemoveMutation',
      operationKind: 'mutation',
      text: 'mutation AppraisalMutationsListRemoveMutation(\n  $id: ID!\n) {\n  deleteAppraisal(id: $id) {\n    id\n  }\n}\n',
    },
  };
})();

(node as any).hash = '6947bb6478f97599ef4b08fe76eeccce';

export default node;
